import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const RECOMPUTE_SCORES_MODAL_MD = `
# Recompute Scores

We'll analyze the latest annual filings and recalculate this company's score.

We automatically recompute scores when filings are released, but this lets you jump ahead of normal processing times and get the data you need for your investment decisions right away.

**We'll notify you by email and in-app when it's done** — usually within a few minutes.

**Keep in mind:** Scores only change when new annual reports are filed. If this company hasn't filed recently, you'll see the same score (we use annual data, not TTM).
`;

type RefreshCompanyDataModalProps = {
  open: boolean;
  loading: boolean;
  isPaidUser: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

function RefreshCompanyDataModal({ open, loading, isPaidUser, onClose, onConfirm }: RefreshCompanyDataModalProps) {
  return (
    <Dialog onClose={onClose} open={open}>
      <DialogContent>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{RECOMPUTE_SCORES_MODAL_MD}</ReactMarkdown>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm} disabled={loading}>
          {isPaidUser ? (loading ? 'Recomputing...' : 'Recompute Scores') : 'Upgrade to continue'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RefreshCompanyDataModal;
